import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { IDadosComparacao } from '../../services/api/jogador/JogadorService';
import { Dataset, Translate } from '@mui/icons-material';
import { reverse } from 'dns';
import { colors, Grid2 } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useAppThemeContext } from '../../contexts';
import { UtilidadeService } from '../../services/api/utilidades/UtilidadesService';



export type IExportProps = {

  children?: React.ReactNode;
  dados1: IDadosComparacao;
  dados2: IDadosComparacao;
  maxValor: number;
}

const valueFormatter = (value: number | null) => `${value}`;

export const GraficoBarrasHorizontalRight: React.FC<IExportProps> = ({ dados1, dados2, maxValor }) => {
  const { themeName } = useAppThemeContext();
 

  let dataSet = [];
  if (dados1.ast !== null && dados2.ast !== null && dados1.ast !== undefined && dados2.ast !== undefined) {
    dataSet.push({
      value: Number(dados1.ast?.toFixed(2)),
      stats: "ast",
      vencedor: dados1.ast < dados2.ast ? 2 : 1
    });
  }
  if (dados1.blk !== null && dados2.blk !== null && dados1.blk !== undefined && dados2.blk !== undefined) {
    dataSet.push({
      value: Number(dados1.blk?.toFixed(2)),
      stats: "blk",
      vencedor: dados1.blk < dados2.blk ? 2 : 1
    });
  }
  if (dados1.dreb !== null && dados2.dreb !== null && dados1.dreb !== undefined && dados2.dreb !== undefined) {
    dataSet.push({
      value: Number(dados1.dreb?.toFixed(2)),
      stats: "dreb",
      vencedor: dados1.dreb < dados2.dreb ? 2 : 1
    });
  }
  if (dados1.fga !== null && dados2.fga !== null && dados1.fga !== undefined && dados2.fga !== undefined) {
    dataSet.push({
      value: Number(dados1.fga?.toFixed(2)),
      stats: "fga",
      vencedor: dados1.fga < dados2.fga ? 2 : 1
    });
  }
  if (dados1.fge !== null && dados2.fge !== null && dados1.fge !== undefined && dados2.fge !== undefined) {
    dataSet.push({
      value: Number(dados1.fge?.toFixed(2)),
      stats: "fge",
      vencedor: dados1.fge > dados2.fge ? 2 : 1
    });
  }
  if (dados1.fgm !== null && dados2.fgm !== null && dados1.fgm !== undefined && dados2.fgm !== undefined) {
    dataSet.push({
      value: Number(dados1.fgm?.toFixed(2)),
      stats: "fgm",
      vencedor: dados1.fgm < dados2.fgm ? 2 : 1
    });
  }
  if (dados1.fgmp !== null && dados2.fgmp !== null && dados1.fgmp !== undefined && dados2.fgmp !== undefined) {
    dataSet.push({
      value: Number(dados1.fgmp?.toFixed(3)),
      stats: "fgmp",
      vencedor: dados1.fgmp < dados2.fgmp ? 2 : 1
    });
  }
  if (dados1.fta !== null && dados2.fta !== null && dados1.fta !== undefined && dados2.fta !== undefined) {
    dataSet.push({
      value: Number(dados1.fta?.toFixed(2)),
      stats: "fta",
      vencedor: dados1.fta < dados2.fta ? 2 : 1
    });
  }
  if (dados1.fte !== null && dados2.fte !== null && dados1.fte !== undefined && dados2.fte !== undefined) {
    dataSet.push({
      value: Number(dados1.fte?.toFixed(2)),
      stats: "fte",
      vencedor: dados1.fte > dados2.fte ? 2 : 1
    });
  }
  if (dados1.ftm !== null && dados2.ftm !== null && dados1.ftm !== undefined && dados2.ftm !== undefined) {
    dataSet.push({
      value: Number(dados1.ftm?.toFixed(2)),
      stats: "ftm",
      vencedor: dados1.ftm < dados2.ftm ? 2 : 1
    });
  }
  if (dados1.ftmp !== null && dados2.ftmp !== null && dados1.ftmp !== undefined && dados2.ftmp !== undefined) {
    dataSet.push({
      value: Number(dados1.ftmp?.toFixed(2)),
      stats: "ftmp",
      vencedor: dados1.ftmp < dados2.ftmp ? 2 : 1
    });
  }
  if (dados1.mplu !== null && dados2.mplu !== null && dados1.mplu !== undefined && dados2.mplu !== undefined) {
    dataSet.push({
      value: Number(dados1.mplu?.toFixed(2)),
      stats: "mplu",
      vencedor: dados1.mplu < dados2.mplu ? 2 : 1
    });
  }
  if (dados1.oreb !== null && dados2.oreb !== null && dados1.oreb !== undefined && dados2.oreb !== undefined) {
    dataSet.push({
      value: Number(dados1.oreb?.toFixed(2)),
      stats: "oreb",
      vencedor: dados1.oreb < dados2.oreb ? 2 : 1
    });
  }
  if (dados1.pf !== null && dados2.pf !== null && dados1.pf !== undefined && dados2.pf !== undefined) {
    dataSet.push({
      value: Number(dados1.pf?.toFixed(2)),
      stats: "pf",
      vencedor: dados1.pf > dados2.pf ? 2 : 1
    });
  }
  if (dados1.pts !== null && dados2.pts !== null && dados1.pts !== undefined && dados2.pts !== undefined) {
    dataSet.push({
      value: Number(dados1.pts?.toFixed(2)),
      stats: "pts",
      vencedor: dados1.pts < dados2.pts ? 2 : 1
    });
  }
  if (dados1.reb !== null && dados2.reb !== null && dados1.reb !== undefined && dados2.reb !== undefined) {
    dataSet.push({
      value: Number(dados1.reb?.toFixed(2)),
      stats: "reb",
      vencedor: dados1.reb < dados2.reb ? 2 : 1
    });
  }
  if (dados1.stl !== null && dados2.stl !== null && dados1.stl !== undefined && dados2.stl !== undefined) {
    dataSet.push({
      value: Number(dados1.stl?.toFixed(2)),
      stats: "stl",
      vencedor: dados1.stl < dados2.stl ? 2 : 1
    });
  }
  if (dados1.stocks !== null && dados2.stocks !== null && dados1.stocks !== undefined && dados2.stocks !== undefined) {
    dataSet.push({
      value: Number(dados1.stocks?.toFixed(2)),
      stats: "stocks",
      vencedor: dados1.stocks < dados2.stocks ? 2 : 1
    });
  }
  if (dados1.threepa !== null && dados2.threepa !== null && dados1.threepa !== undefined && dados2.threepa !== undefined) {
    dataSet.push({
      value: Number(dados1.threepa?.toFixed(2)),
      stats: "3pa",
      vencedor: dados1.threepa < dados2.threepa ? 2 : 1
    });
  }
  if (dados1.threepe !== null && dados2.threepe !== null && dados1.threepe !== undefined && dados2.threepe !== undefined) {
    dataSet.push({
      value: Number(dados1.threepe?.toFixed(2)),
      stats: "3pe",
      vencedor: dados1.threepe > dados2.threepe ? 2 : 1
    });
  }
  if (dados1.threepm !== null && dados2.threepm !== null && dados1.threepm !== undefined && dados2.threepm !== undefined) {
    dataSet.push({
      value: Number(dados1.threepm?.toFixed(2)),
      stats: "3pm",
      vencedor: dados1.threepm < dados2.threepm ? 2 : 1
    });
  }
  if (dados1.to !== null && dados2.to !== null && dados1.to !== undefined && dados2.to !== undefined) {
    dataSet.push({
      value: Number(dados1.to?.toFixed(2)),
      stats: "to",
      vencedor: dados1.to > dados2.to ? 2 : 1
    });
  }
  if (dados1.threepmp !== null && dados2.threepmp !== null && dados1.threepmp !== undefined && dados2.threepmp !== undefined) {
    dataSet.push({
      value: Number(dados1.threepmp?.toFixed(3)),
      stats: "3pmp",
      vencedor: dados1.threepmp < dados2.threepmp ? 2 : 1
    });
  }
  if (dados1.ftmp !== null && dados2.ftmp !== null && dados1.ftmp !== undefined && dados2.ftmp !== undefined) {
    dataSet.push({
      value: Number(dados1.ftmp?.toFixed(3)),
      stats: "ftmp",
      vencedor: dados1.ftmp < dados2.ftmp ? 2 : 1
    });
  }

  const valuesArray = Object.values(dataSet).map(item => item.vencedor);
  const colors = valuesArray.map((e) => (
    e === 1 || e === 1
      ? '#fbc02d' //Vencedor
      : '#a1a0a0' // Default bar color
  ));

  const chartSetting = {
    xAxis: [
      {
        label: 'VALOR',
        reverse: true,
        max: maxValor,
        tickFontSize: UtilidadeService.isMobile() ? 10 : 16,
        labelFontSize: UtilidadeService.isMobile() ? 10 : 16,

      },
    ],

   // width: UtilidadeService.isMobile() ? 300 : 550,
    height: UtilidadeService.isMobile() ? 200 :350,

  };

  return (
    <Grid2 size={{ xs: 12 }} boxShadow={3} width={ UtilidadeService.isMobile() ? "99%" :"90%"} sx={{ backgroundColor: themeName === "dark" ? "#6b6b6b" : "#c1bfbf" }} paddingRight={ UtilidadeService.isMobile() ? 0 : 2}>
      <BarChart
        dataset={dataSet}
        yAxis={[{
          scaleType: 'band',
          dataKey: 'stats',
          colorMap: {
            type: 'ordinal',
            colors: colors,
          },
          tickFontSize: UtilidadeService.isMobile() ? 10 : 16,
        }]}

        series={[{ dataKey: 'value', label: 'Vencedor', valueFormatter, color: '#fbc02d' }]}
        layout="horizontal"
        leftAxis={null}
        rightAxis={{ position: 'right' }}
        barLabel='value'
        grid={{ vertical: true }}
        {...chartSetting}
        sx={{
          ["& .MuiBarLabel-root"]: {
            fill: 'white',
            fontWeight: 'bold',
            fontSize: UtilidadeService.isMobile() ? "0.6em" :"0.9em",
            textAnchor: "end",
          },
        }}

        slotProps={{
          legend: {
            labelStyle: {
              fontSize: UtilidadeService.isMobile() ? 10 : 16,
              fill: 'white',
            }
          }
        }}


      />
    </Grid2>
  );
}